<nb-form-field>
  <nb-icon nbPrefix icon="globe-outline"></nb-icon>
  <input
    #field
    nbInput
    fullWidth
    type="text"
    autocomplete="off"
    data-enter-ignore
    [value]="text"
    [disabled]="isDisabled"
    [nbAutocomplete]="auto"
    placeholder="{{ 'input.defaultLanguage.placeholder' | translate }}"
    (input)="onSearch(field.value)"
    (focus)="onFocus(field)"
    (blur)="onBlur()"
  />
</nb-form-field>
<nb-autocomplete
  #auto
  [handleDisplayFn]="label"
  (selectedChange)="onSelected($event)"
>
  <nb-option [value]="''">
    {{ "input.defaultLanguage.auto" | translate }}
  </nb-option>
  <nb-option *ngFor="let l of filtered" [value]="l.code">
    {{ l.label }}
  </nb-option>
</nb-autocomplete>
